import React, { Component } from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as userActions from "../../actions/user";
import UserNewItem from './UserNewItem';

import Loader from 'react-loader-spinner';
import {IMGIX_PATH} from "../../constants";
import AuthService from "../../lib/AuthService";

class UserContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            imgSrc : ''

        };
        this.Auth = new AuthService();
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        this.showEdituserModal = this.showEdituserModal.bind(this);
    }


    componentDidMount() {
        let data = { userid : this.Auth.getProfile().user_id };
        this.props.allUserData(data);

    }
    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.userData.userCreated !== prevProps.userData.userCreated || this.props.userData.editProfile !== prevProps.userData.editProfile) {

            let data = { userid : this.Auth.getProfile().user_id };
            this.props.allUserData(data);
        }
        if (this.props.userData.searchText !== prevProps.userData.searchText ) {

        }
    }
    showEdituserModal(e,index){

        console.log(this.props.userData.userList[index]);
        let data = {userIndex : index};
        this.props.editUser(data);
        this.props.showUserModal();
    }
    forceUpdateHandler(){
        let data = { userid : this.Auth.getProfile().user_id };
        this.props.allUserData(data);
    }

    render() {

            let userList = (this.props.userData.searchText || this.props.userData.sort) ? this.props.userData.filteredData :  this.props.userData.userList;
           // let userList = this.props.userData ? this.props.userData.userList : undefined;
        //let vignet = this.state.vignet;

        console.log(userList);
       //console.log(this.state.showDetailPop);
        return (
            <div className="list-wrap">
                <div className="list-container">
                    {!userList &&
                    <div className="loaderWrapper">
                        <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                    </div>
                    }
                        <div className="user-member-panel">
                            { userList &&
                            userList.map((entry, index) =>{
                                let imgSrc = IMGIX_PATH+'assets/slider/'+entry.uniqueId+'.jpg?q='+Math.random()+'&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';

                            return(
                                <div className="user-card">
                                    <a href="javascript:void(0);">
                                        <div className="user-card-image">
                                            <img  src={imgSrc}  alt="Member-Thumb" className="my-image" />
                                            <div className="upload-user-icon">
                                                <button className="icon-lib edit-user-icon" onClick={(e)=>this.showEdituserModal(e,index)}></button>
                                            </div>
                                        </div>
                                        <div className="user-card-desc">
                                            <h5>{entry.name}</h5>
                                            <p className="mail-icon">{entry.display_name}</p>
                                            <p className="phone-icon">{entry.phone}</p>
                                        </div>
                                    </a>
                                </div>
                                );
                            }
                            )}
                        </div>

                    <UserNewItem />


                </div>



            </div>

        )
    }

}
function mapStateToProps(state) {
    return {
        userData  :state.user.userListData,
    };

}
export default  withRouter(connect(mapStateToProps, {
    allUserData : userActions.fetchUserData,
    allFilteredData : userActions.searchUser,
    showUserModal : userActions.showUserModal,
    editUser : userActions.editUser,
})(UserContainer));


// WEBPACK FOOTER //
// ./src/components/user/UserContainer.js